<template>
  <div class="may-stay">
    <div class="stay-title">
      <b>说明</b>
      审核通过后，消息将根据相关渠道进行发送。消息的推送时间以审核通过的时间为准。审核驳回的消息不会发送
    </div>
    <div class="stay-table">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="200" align="left">
        </el-table-column>
        <el-table-column
          prop="content"
          align="center"
          label="消息内容"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column align="center" prop="smsSubject" label="消息主体">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.smsSubject === 1
                  ? '企业'
                  : scope.row.smsSubject === 2
                  ? '专员'
                  : '-'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="createBy" label="发送人">
        </el-table-column>
        <el-table-column align="center" prop="smsType" label="推送渠道">
          <template slot-scope="scope">{{
            scope.row.smsTypes | smsTypesFileter
          }}</template>
        </el-table-column>
        <el-table-column align="center" prop="checkStatus" label="审核状态">
          <template slot-scope="scope">
            <span
              style="
                width: 8px;
                height: 8px;
                display: inline-block;
                border-radius: 50%;
                margin-right:5px;
                background:rgba(0, 119, 255,0.9);
              "
            ></span>
            {{ scope.row.checkStatus | statusFilter }}</template
          >
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="提交时间">
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope"
            ><span
              style="color: #1890ff; cursor: pointer"
              @click="examinePopup(scope.row)"
              >审核</span
            ></template
          >
        </el-table-column>
      </el-table>
    </div>
    <div class="stay-page">
      <div>
        <el-button size="small" type="primary" @click="popupShow(0)"
          >通过</el-button
        >
        <el-button size="small" type="danger" @click="popupShow(1)"
          >驳回</el-button
        >
      </div>
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="titleName"
      :visible.sync="dialogVisible"
      top="260px"
      width="25%"
    >
      <el-form
        :model="numberValidateForm"
        ref="numberValidateForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="备注："
          prop="remarks"
          :rules="[{ required: isRequired, message: '备注不能为空' }]"
          label-width="70px"
        >
          <el-input
            type="textarea"
            v-model="numberValidateForm.remarks"
            autocomplete="off"
            placeholder="请输入备注，最多500字"
            :rows="6"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button type="primary" @click="submitForm('numberValidateForm')"
            >确定</el-button
          >
          <el-button @click="resetForm('numberValidateForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="审核"
      :visible.sync="dialogVisibles"
      top="50px"
      width="60%"
    >
      <div class="popup_title">待审核</div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="其他消息" name="otherMessage"></el-tab-pane>
        <el-tab-pane label="钉钉群消息" name="ddGroupMessage"></el-tab-pane>
      </el-tabs>
      <div v-if="activeName == 'otherMessage'">
        <div class="popup_toals">
          共 <b>{{ totalRecords }}</b> 条数据
        </div>
        <el-table
          ref="multipleTable"
          :data="tableChannel"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="{ background: '#fafafa' }"
          height="300"
        >
          <el-table-column
            v-if="isSmsSubject === 1"
            align="center"
            prop="entName"
            label="发送企业"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column align="center" prop="staffName" label="接收人">
          </el-table-column>
          <el-table-column align="center" prop="smsType" label="推送渠道">
            <template slot-scope="scope">{{
              scope.row.smsType | smsTypeFilter
            }}</template>
          </el-table-column>
        </el-table>
        <div class="table-page">
          <el-pagination
            background
            layout="total,prev, pager, next, sizes, jumper"
            :current-page.sync="currentPages"
            @size-change="handleSizeChanges"
            @current-change="handleCurrentChanges"
            :page-size="pageSizes"
            :total="totalRecords"
          >
          </el-pagination>
        </div>
      </div>

      <dd-sms v-else :channelId="channelId"></dd-sms>
      <div class="message-audit">
        <div class="audit-title">消息审核</div>
        <el-form
          :model="popupForm"
          ref="popupForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="操作："
            prop="examine"
            :rules="[{ required: true, message: '请选择审核' }]"
            label-width="70px"
          >
            <el-radio-group v-model="popupForm.examine" @change="examineGroupe">
              <el-radio :label="3">审核通过</el-radio>
              <el-radio :label="2">审核驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="备注："
            prop="remarks"
            :rules="[{ required: isGroupe, message: '备注不能为空' }]"
            label-width="70px"
          >
            <el-input
              type="textarea"
              v-model.number="popupForm.remarks"
              autocomplete="off"
              placeholder="请输入备注，最多500字"
              :rows="4"
            ></el-input>
          </el-form-item>
          <el-form-item style="text-align: center">
            <el-button type="primary" @click="submitFormPopup('popupForm')"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  checkSendSMS,
  checkSmsRecordByPage,
  querySmsRecord,
  getMapProcess
} from '@api/video/video'
import { auditSmsContent } from '@api/corporateInteraction/examine'
import ddSms from './ddSms'
export default {
  components: { ddSms },
  data() {
    return {
      tableData: [
        {
          date: '2016-05-07',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }
      ],
      isGroupe: false,
      currentPage: 1,
      pageSize: 10,
      totalRecord: 0,
      currentPages: 1, // 第二
      pageSizes: 10,
      totalRecords: 0,
      titleName: '批量通过',
      dialogVisible: false,
      dialogVisibles: false,
      isRequired: false,
      numberValidateForm: {
        remarks: ''
      },
      popupForm: {
        examine: 3,
        remarks: ''
      },
      ids: [],
      newChannel: {
        0: '手机短信',
        1: '微信公众号',
        2: '站内消息',
        3: '浙政钉消息',
        4: '浙里办消息',
        5: '钉钉群消息'
      },
      channelId: '',
      channelContent: '',
      tableChannel: [],
      secretKey: '',
      timeKey: null,
      isSmsSubject: '',
      activeName: 'otherMessage',
      smsTypeStr: '0,1,2,4' // 区分钉钉群消息和其他消息
    }
  },

  filters: {
    statusFilter(val) {
      let value = ''
      switch (Number(val)) {
        case 1:
          value = '待审核'
          break
        case 2:
          value = '审核驳回'
          break
        case 3:
          value = '审核通过'
          break

        default:
          break
      }
      return value
    },
    smsTypeFilter(val) {
      let value = ''
      switch (Number(val)) {
        case 0:
          value = '手机短信'
          break
        case 1:
          value = '微信公众号'
          break
        case 2:
          value = '站内消息'
          break
        case 3:
          value = '浙政钉消息'
          break
        case 4:
          value = '浙里办消息'
          break
        case 5:
          value = '钉钉群消息'
          break

        default:
          break
      }
      return value
    },
    smsTypesFileter(name) {
      const a = []
      if (!name) {
        return
      }
      const newChannel = {
        0: '手机短信',
        1: '微信公众号',
        2: '站内消息',
        3: '浙政钉消息',
        4: '浙里办消息',
        5: '钉钉群消息'
      }
      name.map(item => {
        a.push(newChannel[item])
      })
      return a.join('，')
    }
  },
  mounted() {
    this.tabelList()
  },
  methods: {
    // 其他消息和钉钉群消息切换
    handleClick() {
      if (this.activeName == 'otherMessage') {
        this.getDetail()
      }
    },
    // 审核弹窗
    examinePopup(row) {
      console.log(row)
      this.isSmsSubject = row.smsSubject
      this.channelId = row.id
      this.channelContent = row.content
      this.dialogVisibles = true
      this.getDetail(row.id)
    },
    // 查看
    getDetail() {
      let par = {
        pageSize: this.pageSizes,
        pageNum: this.currentPages,
        smsContentId: this.channelId,
        smsTypeStr: this.smsTypeStr
      }
      querySmsRecord(par).then(res => {
        if (res.data.code == '0000') {
          let data = res.data.data
          this.tableChannel = data.list || []
          this.totalRecords = data.total || 0
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //  表格翻页
    handleCurrentChange(currentPage, e) {
      this.currentPage = currentPage
      this.tabelList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.tabelList()
    },
    handleCurrentChanges(currentPage, e) {
      this.currentPages = currentPage
      this.getDetail()
    },
    handleSizeChanges(val) {
      this.pageSizes = val
      this.getDetail()
    },
    handleSelectionChange(val) {
      this.ids = val.map(value => {
        return value.id
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = {
            ids: this.ids,
            checkStatus: this.isRequired ? 2 : 3,
            remark: this.numberValidateForm.remarks
          }
          auditSmsContent(params).then(res => {
            this.dialogVisible = false
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.numberValidateForm.remarks = ''

            this.tabelList()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitFormPopup(formName) {
      const taht = this

      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = {
            ids: [this.channelId],
            checkStatus: this.popupForm.examine,
            remark: this.popupForm.remarks,
            content: this.channelContent
          }
          auditSmsContent(params).then(res => {
            this.dialogVisibles = false
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.popupForm.examine = 3
            this.popupForm.remarks = ''
            this.secretKey = res.data.data
            // this.timeKey = setInterval(taht.getMapStaus, 1000)
            this.tabelList()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 审核状态
    getMapStaus() {
      getMapProcess({ key: this.secretKey }).then(res => {
        console.log(res.data)

        if (res.data.data.process === '1') {
          this.tabelList()
          clearInterval(this.timeKey)
        }
      })
    },
    tabelList() {
      const params = {
        title: 1,
        pageNum: this.currentPage,
        pageSize: this.pageSizes
      }
      checkSmsRecordByPage(params).then(res => {
        const { code, data } = res.data
        if (code === '0000') {
          this.tableData = data.results
          this.totalRecord = data.totalRecord
        }
      })
    },
    resetForm(formName) {
      this.dialogVisible = false
      this.$refs[formName].resetFields()
    },
    examineGroupe(val) {
      if (val === 3) {
        this.isGroupe = false
      } else {
        this.isGroupe = true
      }
    },
    popupShow(e) {
      if (this.ids.length <= 0) {
        this.$message({
          message: '请选择消息',
          type: 'warning'
        })
        return
      }
      if (e === 0) {
        this.titleName = '批量通过'
        this.isRequired = false
      } else {
        this.titleName = '批量拒绝'
        this.isRequired = true
      }
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid #e6e6e6;
  }
  .popup_title {
    margin-bottom: 20px;
    font-size: 15px;
    border-bottom: 1px solid #e6e6e6;
    padding-bottom: 10px;
    > div {
      margin-bottom: 10px;
    }
    color: #000;
  }
  .popup_toals {
    font-size: 14px;
    text-align: right;
    margin: 0 10px 10px;
    b {
      font-size: 15px;
      color: #0099ff;
    }
  }
  .table-page {
    text-align: center;
  }
  .dialog-footer {
    text-align: right;
    margin: 50px;
  }
  .message-audit {
    .demo-ruleForm {
      width: 80%;
    }
    .audit-title {
      height: 40px;
      line-height: 40px;
      background-color: #f7f7f7;
      border-radius: 4px;
      font-size: 14px;
      position: relative;
      padding-left: 25px;
      margin: 10px 0;
    }
    .audit-title::after {
      content: '';
      width: 4px;
      height: 20px;
      background-color: #0066ff;
      position: absolute;
      left: 12px;
      top: 10px;
    }
  }
}
.may-stay {
  .stay-title {
    padding: 12px;
    font-size: 14px;
    color: #333333;
    background-color: #f7f7f7;
    b {
      font-size: 16px;
      margin-right: 20px;
    }
  }
  .stay-table {
    margin-top: 20px;
  }
  .stay-page {
    margin: 16px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
